module.exports = __webpack_public_path__ + "img/learnReason-banner1.9eb47c2a.png";